import { render, staticRenderFns } from "./CourseSpceification.vue?vue&type=template&id=4ffc541e&"
import script from "./CourseSpceification.vue?vue&type=script&lang=js&"
export * from "./CourseSpceification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports